import { ReportsIcon } from "../../assets/svgs/ReportsIcon";
import { TransIcon } from "../../assets/svgs/TransIcon";

export const renderIcon = (name: string, active: boolean) => {
  switch (name.toLocaleLowerCase()) {
    case "reports":
      return <ReportsIcon dark={active} />;
    case "transactions":
      return <TransIcon dark={active} />;
    default:
      return "";
  }
};
